"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = exports.STORYBLOK_BASE_URL = void 0;
exports.STORYBLOK_BASE_URL = 'https://a.storyblok.com';
exports.defaultOptions = {
    smartCrop: true,
    outputPixelDensities: [1, 2, 3],
    breakpoints: [750, 1080, 1366, 1920],
    fitIn: false,
    fitInColor: 'transparent',
    fallbackQuality: 70
};
